import React from "react";

const Characters = ({para ,time, word, chrIndex,handleRestart}) => {
 return (
<>
<div className="content">

{ para.split('').map((char,index) => (
  <span key={index}
  className={`
  char
  ${index === chrIndex ? 'active' : ''}
  ${
    word[index] === char ? 'correct' : index < chrIndex ? 
    'incorrect' : ''
  }
  `}>{char}</span>
))}
{time <= 0 && (
   <span className="restart" onClick={handleRestart}>
          &#x27F3;
        </span>
) }
</div>

</>
    )
}
export default Characters;